import { memo, useCallback, useEffect, useMemo, useState, useRef } from 'react'
import './AccountSettings.scss'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { Tab, ErrorAlert, PageLoadingSpinner } from 'ui_kit_qmd'
import { useSelector } from 'store/hooks/useSelector'
import errorIcon from '../../images/common/error-icon.svg'
import AccountSettingsPageTitle from './AccountSettingsPageTitle/AccountSettingsPageTitle'
import { ConfirmationPopup } from '../../components/confirmation-popup/confirmationpopup'
import { LOGOUT } from '../../store/auth/AuthConstants'
import { AccountSection } from './AccountSection/AccountSection'
import { SecuritySection } from './SecuritySection/SecuritySection'
import { getProviderProfile } from '../../store/waitingRoom/WaitingRoomThunk'
import { changeTabs, setAccountSettingsError, setTabs } from '../../store/accountSettings/AccountSettingsActions'
import { PreferencesSection } from './PreferencesSection/PreferencesSection'
import { LicensesSection } from './LicensesSection/LicensesSection'
import { PageLayout } from 'components/page-layouts/PageLayout'
import { safeLocalStorage } from '@quickmd-llc/frontend-utils'

const unsavedChangesPopUpBoxStyle = { marginTop: 200 }
const errorAlertStyleContainer = { width: 550 }

export const AccountSettings = memo(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const profileLoading = useSelector((state) => state.waitingRoomReducer.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.accountSettings.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.accountSettings.error)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const tabs = useSelector((state) => state.accountSettings.tabs)
  const [isEditMode, setIsEditMode] = useState(false)
  const [isConfirmationPopUpOpened, setIsConfirmationPopUpOpened] = useState(false)
  const [saveChangesFromPopUp, setSaveChangesFromPopUp] = useState(false)
  const [isChangedData, setIsChangedData] = useState(false)
  const [newActiveTab, setNewActiveTab] = useState('')
  const phoneInputRef = useRef(null)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const toggleIsEditMode = (newStatus) => {
    setIsEditMode(newStatus)
    safeLocalStorage.set('previousTabsAccountSettings', JSON.stringify(false))
  }

  useEffect(() => {
    window.onpopstate = () => {}
    dispatch(setTabs())
    dispatch(getProviderProfile())
  }, [])

  useEffect(() => {
    window.onbeforeunload = function () {
      if (isChangedData) {
        return 'Do you want to leave this page?'
      }
    }
    if (isChangedData) {
      window.history.pushState({}, '', '/accountsettings')
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      window.onpopstate = (e) => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        window.history.forward(1)
        setIsConfirmationPopUpOpened(true)
      }
    } else if (isEditMode) {
      window.history.pushState({}, '', '/accountsettings')
      window.onpopstate = () => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        window.history.forward(1)
        setIsEditMode(false)
      }
    } else {
      if (safeLocalStorage.get('previousTabsAccountSettings')) {
        // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
        if (!JSON.parse(safeLocalStorage.get('previousTabsAccountSettings'))) {
          window.history.pushState({}, '', '/accountsettings')
        }
      }
      if (safeLocalStorage.get('isLastPageWasPatientChart') === 'true') {
        window.onpopstate = null
        safeLocalStorage.remove('isLastPageWasPatientChart')
      } else {
        // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
        window.onpopstate = (e) => {
          if (safeLocalStorage.get('previousTabsAccountSettings')) {
            // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
            if (JSON.parse(safeLocalStorage.get('previousTabsAccountSettings'))) {
              safeLocalStorage.set('previousTabsAccountSettings', JSON.stringify(false))
            } else {
              // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
              window.history.back(2)
            }
          }
        }
      }
    }

    return () => {
      window.onbeforeunload = () => {}
    }
  }, [isChangedData, isEditMode])

  useEffect(() => {
    setTimeout(() => {
      if (error) {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setAccountSettingsError())
      }
    }, 3500)
  }, [error])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChangeActiveTabs = (title) => () => {
    dispatch(changeTabs(title))
  }

  const UnsavedPopUpSecondaryBtnAction = useCallback(() => {
    toggleIsEditMode(false)
    setIsConfirmationPopUpOpened(false)
    setIsChangedData(false)
    if (newActiveTab) {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (newActiveTab.redirect === 'logout') {
        setNewActiveTab('')
        dispatch({ type: LOGOUT, reason: 'manual' })
        safeLocalStorage.set('isSidePanelCollapsed', JSON.stringify(false))
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        navigate(`/${newActiveTab.redirect}`, { replace: true })
        setNewActiveTab('')
      }
    }
  }, [dispatch, navigate, newActiveTab])

  const unSavedPopUpPrimaryBtnAction = useCallback(() => {
    setSaveChangesFromPopUp(true)
  }, [])

  const unSavedPopUpCloseAction = useCallback(() => {
    setIsConfirmationPopUpOpened(false)
    setNewActiveTab('')
  }, [])

  const settingPageContainerWrapperStyle = useMemo(
    () => ({
      paddingBottom: isEditMode ? 275 : 42,
      overflowY: isEditMode ? 'hidden' : 'auto',
    }),
    [isEditMode],
  )
  return (
    <div>
      {error && !(loading || profileLoading) ?
        <div className='alert-error-account-settings-wrapper'>
          <ErrorAlert styleContainer={errorAlertStyleContainer} errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}
      {isConfirmationPopUpOpened ?
        // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
        <ConfirmationPopup
          title='Unsaved changes'
          primaryBtnAction={unSavedPopUpPrimaryBtnAction}
          primaryBtnText='Save changes'
          popUpBoxStyle={unsavedChangesPopUpBoxStyle}
          secondaryBtnAction={UnsavedPopUpSecondaryBtnAction}
          secondaryBtnText='Discard changes'
          msg='You have unsaved changes made to the account which will be lost if you navigate away. Would you like to save these changes?'
          closeAction={unSavedPopUpCloseAction}
        />
      : null}

      {profileLoading ?
        <PageLoadingSpinner />
      : null}

      <PageLayout>
        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <div className='settings-page-container' style={settingPageContainerWrapperStyle}>
          {!isEditMode && (
            <>
              <AccountSettingsPageTitle
                // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                isEditMode={isEditMode}
                toggleIsEditMode={toggleIsEditMode}
                setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
              />
              <div className='settings-page-tabs-wrapper'>
                {/*
                 // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
                {tabs?.map(({ name, isActive }, idx) => (
                  <Tab
                    id={idx}
                    key={name}
                    className='settings-page-tab'
                    isActive={isActive}
                    title={name}
                    onChangeActive={onChangeActiveTabs(name)}
                  />
                ))}
              </div>
            </>
          )}
          {tabs?.[0]?.isActive ?
            <AccountSection
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isEditMode={isEditMode}
              toggleIsEditMode={toggleIsEditMode}
              setNewActiveTab={setNewActiveTab}
              newActiveTab={newActiveTab}
              setIsChangedData={setIsChangedData}
              setSaveChangesFromPopUp={setSaveChangesFromPopUp}
              saveChangesFromPopUp={saveChangesFromPopUp}
              setIsConfirmationPopUpOpened={setIsConfirmationPopUpOpened}
              phoneInputRef={phoneInputRef}
            />
          : null}
          {tabs?.[1]?.isActive ?
            <LicensesSection />
          : null}
          {tabs?.[2]?.isActive ?
            <SecuritySection isEditMode={isEditMode} toggleIsEditMode={toggleIsEditMode} />
          : null}
          {tabs?.[3]?.isActive ?
            <PreferencesSection />
          : null}
        </div>
      </PageLayout>
    </div>
  )
})
